export function getWebshopItem(id: string, language: string): string {
  return `
      query WebshopArticleMarketigInfo {
        productPage(
          locale:${language},
          filter: {
            id: {eq: "${id}"}
          })
        {
          metainfo { ... on ProductPageMetainfoRecord {
              location { id }
              price,
              stockKeepingUnit { id }
            } 
          },
          productName,
          title,
          subtitle,
          titleImage {
            focalPoint {x,y},
            url
          },
          preface,
          whatIsTitle,
          whatIsParagraphs { ... on SingleLineTextRecord {text} },
          marketingInfo {
            ... on ProductPageMarketingInfoRecord {
              title,
              text,
              picture {
                url,
                focalPoint {x, y}
              }
            }
          },
          dosingText,
          dosingParagraphs { ... on SingleLineTextRecord { text }},
          ingredientsBackground {
            focalPoint {x,y},
            url
          },
          ingredients {
            ... on ProductPageIngredientRecord {
              name,
              nrv,
              quantity,
              subingredients { ... on ProductPageIngredientRecord {
                name,
                nrv,
                quantity,
              }}
            }
          }
        }
      }  
    `;
}

export function getLocation(language: string): string {
  return `
      query WebshopLocation {
        location(filter: {
          locationCode: {eq: "${language}"}
        })
        {
          id,
          locationCode,
          currency,
          currencyLocalized,
        }
      }
    `;
}

export function getSKU(id: string, language: string): string {
  return `
      query WebshopSKU {
        stockKeepingUnit(
          locale: ${language},
          filter: {
            id: {eq: "${id}"}
          }
      )
        {
          packaging,
          packagingLongName
        }
      }
    `;
}

export function getGeneralTranslations(language: string): string {
  return `
      query WebshopArticleTitleImage {
        generalProductPage(locale: ${language})
        {
          packaging,
          putInBasket,
          dosingTitle,
          ingredientsNrvExplanation,
          ingredientsTitle,
          ingredientsQuantityHeader
        }
      }
    `;
};